var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L18.9236 5.0889L24 2.14359L23.9875 8.01252L29.8564 8L26.9111 13.0764L32 16L26.9111 18.9236L29.8564 24L23.9875 23.9875L24 29.8564L18.9236 26.9111L16 32L13.0764 26.9111L8 29.8564L8.01252 23.9875L2.14359 24L5.0889 18.9236L0 16L5.0889 13.0764L2.14359 8L8.01252 8.01252L8 2.14359L13.0764 5.0889L16 0Z",
    fill: "#E7B92A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91455 18.4004V13.9204H8.95775L11.4282 16.9028H10.9354V13.9204H12.177V18.4004H11.1338L8.66335 15.418H9.15615V18.4004H7.91455ZM14.2356 15.6548H16.3156V16.602H14.2356V15.6548ZM14.3252 17.4212H16.6676V18.4004H13.0708V13.9204H16.5844V14.8996H14.3252V17.4212ZM18.4155 18.4004L16.9627 13.9204H18.2683L19.4907 17.7988H18.8315L20.1179 13.9204H21.2827L22.4987 17.7988H21.8651L23.1259 13.9204H24.3355L22.8827 18.4004H21.5259L20.4891 15.1044H20.8539L19.7723 18.4004H18.4155Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewReview);
export default __webpack_public_path__ + "static/media/new-review.5cd25e2500c160150c550b27ff4abd68.svg";
export { ForwardRef as ReactComponent };